import { useEffect, useState } from "react";
import { api, type ReleaseRow } from "../api";
import { useProjects } from "../project-context";
import { relTime } from "../time";

export function Releases() {
  const { selected, loading: projLoading } = useProjects();
  const [rows, setRows] = useState<ReleaseRow[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!selected) return;
    setLoading(true);
    api.releases(selected.id).then(setRows).catch(() => setRows([])).finally(() => setLoading(false));
  }, [selected]);

  if (projLoading) return <div className="spin" />;
  if (!selected) return <div className="card reveal" style={{ marginTop: 40 }}><div className="empty">ingen prosjekt valgt</div></div>;

  return (
    <div>
      <div className="page-head">
        <div>
          <span className="eyebrow">{selected.name}</span>
          <h1 className="page-title">Releases</h1>
        </div>
      </div>

      {loading ? (
        <div className="spin" />
      ) : rows.length === 0 ? (
        <div className="card reveal">
          <div className="empty">
            ingen releases ennå — send <span className="mono">release</span> i SDK-en (
            <span className="mono">init(&#123; release: "1.2.3" &#125;)</span>)
          </div>
        </div>
      ) : (
        rows.map((r) => (
          <div className="rel-row reveal" key={r.version}>
            <div>
              <div className="rel-version">{r.version}</div>
              <div className="rel-date">opprettet {relTime(r.created_at)}</div>
            </div>
            <div className="metric">
              <div className="big" style={{ color: r.issues > 0 ? "var(--coral)" : "var(--muted)" }}>{r.issues}</div>
              <div className="lab">Issues</div>
            </div>
            <div className="metric">
              <div className="big">{r.events}</div>
              <div className="lab">Feil</div>
            </div>
            <div className="metric">
              <div className="big" style={{ fontSize: 12 }}>{r.last_error ? relTime(r.last_error) : "—"}</div>
              <div className="lab">Siste feil</div>
            </div>
          </div>
        ))
      )}
    </div>
  );
}
